export const DEFAULT_SORT_BY = 'updatedAt_desc';
export const SORT_BY_OLDER = 'createdAt_asc';
export const DEFAULT_PER_PAGE = 50;
export const NO_IMAGE_ALT = 'NO IMAGE FOUND';
export const MAX_PRODUCT_VARIANT_EDITORS_CHOICE = 52;